const openButton = document.querySelector('.open-video-button');
const closeButton = document.querySelector('.close-modal');
const videoModal = document.querySelector('.featured-video-modal');
// const videoEmbed = document.querySelector('.featured-video-embed');

openButton?.addEventListener('click', e => {
  e.preventDefault();
  videoModal?.classList.toggle('open');

  // const iframes = document.querySelectorAll('iframe');

  // if (iframes.length == 0) {
  //   console.log('adding iframe');
  //   const iframe = document.querySelector('iframe');
  //   const vidUrl = iframe?.getAttribute('rel-iframe');
  //   console.log(vidUrl);
  //   iframe?.setAttribute("src", "https://youtu.be/8Se43-bWPm0");
  //   // const iframe = document.createElement('iframe');
  //   // iframe.src = "https://youtu.be/8Se43-bWPm0";
  //   // iframe.width = "100%";
  //   // iframe.height = "100%";
  //   // videoEmbed?.appendChild(iframe);
  // }
});

closeButton?.addEventListener('click', e => {
  e.preventDefault();
  const iframes = document.querySelectorAll('iframe');
  videoModal?.classList.toggle('open');
  Array.prototype.forEach.call(iframes, iframe => {
    iframe.contentWindow.postMessage(
      '{"event":"command","func":"stopVideo","args":[]}',
      '*',
    );
  });
});
